var React = require('react');

function NumberStoryBgTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.8683 3.21816L1.00055 49.9451M21.8683 3.21816L35.6359 28.3111M21.8683 3.21816L69.961 30.7422M1.00055 49.9451L35.6359 28.3111M1.00055 49.9451L69.961 30.7422M35.6359 28.3111L69.961 30.7422","stroke":"#FF547D"}));
}

NumberStoryBgTriangle.defaultProps = {"width":"75","height":"65","viewBox":"0 0 75 65","fill":"none"};

module.exports = NumberStoryBgTriangle;

NumberStoryBgTriangle.default = NumberStoryBgTriangle;
